'use client';

import React from 'react';
import { TasticProps } from '../types';
import ShippingBanner from 'components/commercetools-ui/organisms/shipping-banner';
import { ShippingBannerPayload } from 'types/next';

const ShippingBannersTastic = ({ data }: TasticProps<ShippingBannerPayload>) => {
  const shippingBannerContent = data?.data?.dataSource?.ShippingBannerLinks;
  return (
    <>
      <ShippingBanner shippingBannerContent={shippingBannerContent} />
    </>
  );
};

export default ShippingBannersTastic;
